import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/it";

dayjs.locale("it");

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return "Si è verificato un errore. Riprova.";
};

export const fmtDate = (d) => (d ? dayjs(d).format("D MMM YYYY") : "");

export const fmtEur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const notifyDeadlines = () => window.dispatchEvent(new Event("bz:deadlines"));

export const daysLeft = (d) => dayjs(d).startOf("day").diff(dayjs().startOf("day"), "day");

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function openFile(path) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank", "noopener");
}

export const CATEGORIES = ["Tasse", "Casa", "Salute", "Auto", "Lavoro", "Famiglia", "Banca", "Utenze", "Identità", "Altro"];

export function startLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}


export const track = (step) => {
  const k = `bz_t_${step}`;
  if (sessionStorage.getItem(k)) return;
  sessionStorage.setItem(k, "1");
  api.post("/track", { step }).catch(() => {});
};
